import { render, staticRenderFns } from "./SummaryFreezer.vue?vue&type=template&id=0d19c31a&"
import script from "./SummaryFreezer.vue?vue&type=script&lang=js&"
export * from "./SummaryFreezer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports